export class GoPay {
  race;
  goId: string;
  secureKey: string;
  clientId: string;
  clientSecret: string;
  userName: string;
  passwd: string;
  id: string;
  currency: string;
  orderDescription: string;
  itemsType: string;
  itemsName: string;
  itemsProductUrl: string;
  itemsEan: string;
  returnUrl: string;
  notificationUrl: string;
}
